import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import ProductInfo from "./product-details/product-info";
import LastProcessorInfo from "./product-details/last-processor-info";
import AdditionalInfo from "./product-details/additional-info";
import RawMaterialInfo from "./product-details/raw-material-info";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../shared/components/table/custom-actions";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../shared/components/stepper/steppers";
import {
  IAdditionalInfo,
  ICertifiedProductDetails,
  ILastProcessorInfo,
  ITCProduct,
  ITcProductRawMaterialInformation,
  ITcProductStandardDetailsInformation,
  ITCRawMaterial,
  mapToPayload,
  payloadToMap,
} from "../../../tc-models/tc-req-dto/tc-certified-product-details.req_dto";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../shared/components/buttons/floating-button-container";
import { transactionCertificateService } from "../../../tc-service/transaction-certificate.service";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import useNotification from "../../../../../shared/hooks/useNotification";
import { useFormActions } from "../../../../../shared/hooks/form-builder.hooks";
import { useApi } from "../../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import {
  DELETECONFIG,
  TC_CREATE_ROUTE_CONFIG,
  TCAppConfig,
} from "../../../../../shared/app-configs/tc-app-configs";
import AlertPopup from "../../../../../shared/components/modals/alert-moadal";
import _ from "lodash";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import TcproductStandard from "./product-details/tc-standard-details";
import { Utills } from "../../../../../shared/app-configs/utilit";
import RenderDetailPanel from "./render-detail-panel";
import {
  getShipmentIdsByNumbers,
  getShipmentIdsByProductId,
  mapProductData,
  mapProductDataToStepData,
  ProductShipmentResponse,
} from "./certified-products.model";
import { ApiShipmentResponseItem } from "../shipments/shipments.model";
import { fetchProductaddDetails } from "./product-api";
import { dtrackItService } from "../../../tc-service/dtrackit.service";
import zIndex from "@mui/material/styles/zIndex";
import { Pagination } from "../../../../../shared/hooks/useRecordStore";

interface CertifiedProductsComponentsProps {
  onNextTab: () => Promise<void>;
}

const CertifiedProductsComponents: React.FC<
  CertifiedProductsComponentsProps
> = ({ onNextTab }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [editingIndex, setEditingIndex] = useState<number>(-1);
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [apiShipmentsData, setAPIData] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [pendingSave, setPendingSave] = useState<any | null>(null);
  const [originalValue, setOriginalValue] = useState("");
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const [getPreviousProductNo, setPreviousProductNo] = useState("");
  const { isRestrictPopUpSave, setRestrictPopUpSave, getTCStandardGOTS, isAdmin } =
    useTransactionCertificateStore();
  const [getEditExistingShipment, setEditExistingShipment] = useState({
    index: -1,
    value: "",
  });
  const {
    getCurrentFormValues,
    getCurrentTableData,
    updateTableData,
    replaceTableDatas,
    updateTableRowbyIndex,
    removeTableRowbyIndex,
    updateField,
    setDeleteSave,
    setEditSave,
    resetFormValueByPage,
    getDeleteSave,
  } = useFormActions("certified-products");
  const initTcProduct: ITCProduct = {
    tcProductShipmentNo: [], //'',
    // associatedShipmentNo: '',
    tcProductNo: "",
    tcProductCategoryCode: "",
    tcProductProductionDate: "",
    tcNetShippingWeight: "",
    tcProductSupplementaryWeight: "",
    tcProductOrderNo: [],
    tcProductArticleNo: "",
    tcProductNumberOfUnits: "",
    tcProductUnitsMetric: "",
    tcProductInfoAssociatedTc: "",
    // tcProductCertifiedWeight: '',
    // tcProductStandardLabelGrade: '',
    tcProductOrder: "",
    tcProductCategoryUserSpecificTerm: "",
    tcProductDetailCode: "",
    tcProductDetailUserSpecificTerm: "",
  };

  const initLastProcessorInfo: ILastProcessorInfo = {
    tcIsLastProcessorTECertitfied: "Y",
    tcProductLastProcessorCountry: "",
    tcProductLastProcessorLicenseNo: "",
    tcProductLastProcessorName: "",
    tcProductLastProcessorTeId: "",
  };

  const initAdditonalInfo: IAdditionalInfo = {
    tcProductInfoAdditional: "",
    tcProductInfoFabricWeightAndConstruct: "",
    tcProductInfoFabricWeightOfFinishedProduct: "",
    tcProductInfoFiberLength: "",
    tcProductInfoTrimsExcluded: "",
    tcProductInfoYarnCount: "",
    tcProductAdditives: [],
    tcProductAdditivesWeight: null,
  };
  const initStandardInfo: ITcProductStandardDetailsInformation[] = [];
  const initRawMaterialInfo: ITcProductRawMaterialInformation[] = [];
  const [shipmentData, setShipmentData] = useState<ApiShipmentResponseItem[]>(
    []
  );
  const [tableData, setTableData] = useState<ProductShipmentResponse[]>([]);
  const [stepData, setStepData] = useState({
    productInfo: initTcProduct,
    standardInfo: initStandardInfo,
    lastProcessorInfo: initLastProcessorInfo,
    additionalInfo: initAdditonalInfo,
    rawMaterialInfo: initRawMaterialInfo,
  });

  const [isDeleteOnly, setDeleteOnly] = useState(false);

  const productInfoRef = useRef<any>(null);
  const lastProcessorInfoRef = useRef<any>(null);
  const additionalInfoRef = useRef<any>(null);
  const rawMaterialInfoRef = useRef<any>(null);
  const toggleDrawer = () => {
    setActiveStep(0);
    if (drawerOpen) {
      setStepData({
        productInfo: initTcProduct,
        standardInfo: initStandardInfo,
        lastProcessorInfo: initLastProcessorInfo,
        additionalInfo: initAdditonalInfo,
        rawMaterialInfo: initRawMaterialInfo,
      });
      setProductId(null);
      setShipmentId(null);
      setPendingSave(null);
      setEditingIndex(-1);
    }
    setRestrictPopUpSave(false);
    setDrawerOpen((prev) => !prev);
  };
  const { TE_ID, formtype } = useParams<string>();
  const hasCreateTc: boolean = formtype === "create-tc";
  const formRefs = [
    productInfoRef,
    additionalInfoRef,
    lastProcessorInfoRef,
    additionalInfoRef,
    rawMaterialInfoRef,
  ];
  const hasSubmitTC: boolean = formtype === "submited-tc";
  const [productId, setProductId] = useState<string | null>(null);
  const [deleteShpId, setDeleteShpId] = useState<string | null>(null);
  const [deleteShpNo, setDeleteShpNo] = useState<string | null>(null);
  const [tcProductNo, setTcProductNo] = useState<string | null>(null);
  const [isValueChanged, setIsValueChanged] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [shipmentId, setShipmentId] = useState<string | null>(null);
  const [shipmentNo, setShipmentNo] = useState<string | null>(null);
  const [productCategory, setProductCategory] = useState([]);
  const [totalCertifiedWeight, setTotalCertifiedWeight] = useState<number>(0);
  const [disableOnEdit, setDisableOnEdit] = useState<boolean>(false);
  const {
    loading,
    error,
    executeGet,
    setLoadingState,
    executePost,
    executeDelete,
  } = useApi();
  // const modalAttributes = useApi();
  const { loading: nextLoader, executeGet: executeShipment } = useApi();
  const { notify } = useNotification();
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState<number>(0);
  const handleDataUpdate = (stepKey: string, updatedData: any) => {
    setStepData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };
  const shipmentFormData = async () => {
    try {
      const response = await executeShipment(TCAppConfig.GET_SHIPMENTS_LIST, {
        tcId: TE_ID,
      });
      setShipmentData(response?.data.response);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };
  const steps = [
    {
      label: "Product Info",
      content: (
        <ProductInfo
          formRef={productInfoRef}
          productData={stepData.productInfo}
          setProductData={(data) => handleDataUpdate("productInfo", data)}
          shipmentId={shipmentId || ""}
        />
      ),
    },
    {
      label: "Raw Material Info",
      content: (
        <RawMaterialInfo
          rawMaterialInfoData={stepData.rawMaterialInfo} // Pass the array
          setRawMaterialInfoData={(data) =>
            handleDataUpdate("rawMaterialInfo", data)
          }
        />
      ),
    },
    {
      label: "Last Processor Info",
      content: (
        <LastProcessorInfo
          formRef={lastProcessorInfoRef}
          lastProcessorData={stepData.lastProcessorInfo}
          setLastProcessorData={(data) =>
            handleDataUpdate("lastProcessorInfo", data)
          }
        />
      ),
    },
    {
      label: "Additional Info",
      content: (
        <AdditionalInfo
          formRef={additionalInfoRef}
          additionalInfoData={stepData.additionalInfo}
          productCategoryCode={stepData.productInfo.tcProductCategoryCode}
          productDetailCode={stepData.productInfo.tcProductDetailCode}
          setAdditionalInfoData={(data) =>
            handleDataUpdate("additionalInfo", data)
          }
        />
      ),
    },
    {
      label: "Tc Standard Details",
      content: (
        <TcproductStandard
          TE_ID={TE_ID}
          standardData={stepData.standardInfo} // Pass the array
          productData={stepData.productInfo}
          rawMaterialData={stepData.rawMaterialInfo}
          rawMaterialInfoData={stepData.rawMaterialInfo}
          setStandardData={(data) => handleDataUpdate("standardInfo", data)}
          setTotalCertifiedWeight={setTotalCertifiedWeight}
          disableOnEdit={disableOnEdit}
          setDisableOnEdit={setDisableOnEdit}
        />
      ),
    },
  ];

  const getProductCategory = async () => {
    try {
      const result: any = await dtrackItService.getProductCategory();

      Utills.cl(`result getProductDetails ${JSON.stringify(result)}`);

      const prdtDetails = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      Utills.cl(`prdtDetails ${JSON.stringify(prdtDetails)}`);
      return prdtDetails;
    } catch (err) {
      Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
    }
  };

  const fetchProductDetails = async () => {
    try {
      const response: any = await executeGet(
        TCAppConfig.GET_PRODUCT_RAWMATERIAL_INFO_LIST,
        { 
          tcId: TE_ID,
          limit: pagination?.pageSize,
          offset: pagination?.pageIndex * pagination?.pageSize
        }
      );

      let result = response.data;
      let getProductCategoriesStore = await getProductCategory();

      result.response = result.response.map((res: any) => {
        return {
          ...res,
          tcProductCategoryCodeDescription:
            getProductCategoriesStore.find(
              (option: any) => option.value === res.tcProductCategoryCode
            )?.label || "",
        };
      });

      setTableData(result.response);
      setAPIData(result.response);
      setRowCount(response?.data?.no_of_records);
      setDeleteSave(false);
      setNextEnabled(true);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  const handleConfirmSave = async () => {
    try {
      if (!productId) {
        notify("No product selected for deletion", "error");
        return;
      }
      // If we have a pending save payload, save it first
      if (pendingSave) {
        delete pendingSave.productId;
        await handleSave(pendingSave);
        setPendingSave(null);
      }

      // Then delete the existing record
      const res = await executeDelete(`${TCAppConfig.TC_DELETE_API}`, {
        pageName: DELETECONFIG.product,
        tcId: TE_ID,
        productId: productId,
        shipmentId: deleteShpId ?? shipmentId, //getShipmentIdsByProductId(tableData, productId),
        shipmentNo: encodeURIComponent(
          encodeURIComponent(deleteShpNo ?? shipmentNo ?? "")
        ),
        productNo: encodeURIComponent(encodeURIComponent(tcProductNo ?? "")),
      });

      if (res?.status === 200) {
        setDialogOpen(false);
        setProductId(null);
        fetchProductDetails();
        notify("Successfully processed", "success");
      }
    } catch (error) {
      console.error("Error in handleConfirmSave:", error);
      notify("Failed to process the request", "error");
    }
  };

  const handleDeleteSaveData = async () => {
    if (TE_ID) {
      if (!isDeleteOnly && getDeleteSave()) {
        const userFilledValues = getCurrentFormValues();
        updateTableRowbyIndex(editingIndex, userFilledValues);
      } else if (isDeleteOnly && !getDeleteSave()) {
        removeTableRowbyIndex(editingIndex);
        const deletedData = data.filter((item, index) => {
          index !== editingIndex;
        });
        setData(deletedData);
        setEditingIndex(-1);
      }

      const certifiedPrdtData: any = getCurrentTableData();
      const totalNetShippingWeight = certifiedPrdtData.reduce(
        (sum: any, item: any) => {
          return sum + parseFloat(item.tcNetShippingWeight || 0);
        },
        0
      );
      const payload = mapToPayload(
        certifiedPrdtData,
        TE_ID,
        totalNetShippingWeight
      );
      // TODO Commenetexd for demo
      setDeleteSave(false);
      setEditSave(false);
      const result: any = await executePost(
        TCAppConfig.CERTIFIED_PRODUCT_DETAILS_ENDPOINT,
        payload
      );
      if (result.status == 200) {
        notify("Saved Successfully", "success");
        if (!isDeleteOnly) toggleDrawer();

        setDeleteOnly(false);
        await fetchProductDetails();
      } else {
        setLoadingState(false);
        notify("Unable to Save", "error");
      }
    }
  };

  // TO DO Port Changes 2
  const handleCancelSave = () => {
    setDialogOpen(false);
    if (drawerOpen) {
      toggleDrawer();
    }
  };

  const setZustandInitialState = (initialState?: any) => {
    const defaultState = {
      associatedShipmentNo: "",
      tcProductNo: "",
      tcProductCategoryCode: "",
      tcProductCategoryUserSpecificTerm: "",
      tcProductDetailCode: "",
      tcProductDetailUserSpecificTerm: "",
      tcProductProductionDate: "",
      tcNetShippingWeight: "",
      tcProductSupplementaryWeight: "",
      tcProductOrderNo: [""],
      tcProductShipmentNo: [""],
      tcProductArticleNo: "",
      tcProductNumberOfUnits: "",
      tcProductUnitsMetric: "",
      tcProductInfoAssociatedTc: "",
      // tcProductCertifiedWeight: "",
      // tcProductStandardLabelGrade: [],
      tcIsLastProcessorTECertitfied: "Y",
      tcProductLastProcessorTeId: "",
      tcProductLastProcessorName: "",
      tcProductLastProcessorCountry: "",
      tcProductLastProcessorLicenseNo: "",
      tcProductInfoFiberLength: "",
      tcProductInfoYarnCount: "",
      tcProductInfoFabricWeightAndConstruct: "",
      tcProductInfoFabricWeightOfFinishedProduct: "",
      tcProductInfoTrimsExcluded: "",
      tcProductAdditives: [],
      tcProductAdditivesWeight: null,
      tcProductInfoAdditional: "",
      "raw-material-info": [
        {
          tcProductRawMaterialOrder: 0,
          tcProductRawMaterialCode: "",
          tcProductRawMaterialPercentage: "",
        },
        {
          tcProductRawMaterialOrder: 0,
          tcProductRawMaterialCode: "",
          tcProductRawMaterialPercentage: "",
        },
      ],
    };
    //set zustand state inital values
    Object.entries(initialState ?? defaultState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };

  useEffect(() => {
    // setZustandInitialState(null);
    // const certifiedProductsDatas = getCurrentTableData()
    // Utills.cl(`certifiedProductsDatas ${certifiedProductsDatas}`)
    // if (certifiedProductsDatas != null) {
    //   setData(certifiedProductsDatas)
    // }
    if (TE_ID) {
      fetchProductDetails();
    } else {
      updateTableData([]);
    }
    // TO DO Port Changes 5
    resetFormValueByPage();
    shipmentFormData();
    setZustandInitialState(null);
    setRestrictPopUpSave(false);
  }, [TE_ID, pagination?.pageIndex]);

  const handleNext = async () => {
    if (formRefs[activeStep]?.current) {
      let stepSuccess = true;
      if (activeStep === 0) {
        const shipmentIdParam = shipmentData?.find(
          (shipment) =>
            shipment?.tcShipmentNo ===
            formRefs[activeStep]?.current?.values?.tcProductShipmentNo
        );
        const existingProduct = tableData?.find(
          (product) =>
            product?.tcProductNo ===
            formRefs[activeStep]?.current?.values?.tcProductNo
        );
        const url = `${
          TCAppConfig.PRODUCT_WEIGHT_VALIDATE
        }?tcId=${TE_ID}&shipmentId=${shipmentIdParam?.shipmentId}&weight=${
          formRefs[activeStep]?.current?.values?.tcNetShippingWeight
        }${
          isEdit
            ? `&productId=${
                existingProduct ? existingProduct?.productId : productId
              }`
            : ""
        }`;
        try {
          const result: any = await executeShipment(url);
          if (result.status === 409) {
            stepSuccess = false;
          }
        } catch (err) {
          console.error(err);
        }
      }
      if (stepSuccess) {
        const errors = await formRefs[activeStep]?.current.validateForm();
        await formRefs[activeStep]?.current.submitForm();
        if (Object.keys(errors).length === 0) {
          setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
        } else {
          notify("Please Enter the Required Values", "error");
        }
      }
    } else {
      if (activeStep === 1) {
        const totalPercentage = stepData.rawMaterialInfo.reduce((sum, item) => {
          const percent = parseFloat(
            item.tcProductRawMaterialPercentage || "0"
          );
          return sum + (isNaN(percent) ? 0 : percent);
        }, 0);
        const roundedTotal = parseFloat(totalPercentage.toFixed(2));
        if (stepData.rawMaterialInfo && stepData.rawMaterialInfo.length <= 0) {
          notify("Raw Material Info is Required", "error");
          return;
        }
        if (roundedTotal !== 100) {
          notify(
            "Total Product Raw Material Percentage should be 100",
            "error"
          );
          return;
        }
        if (stepData.rawMaterialInfo.length > 0) {
          setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
        } else {
          notify("Please Enter the Required Values", "error");
        }
      }
      if (activeStep === 4) {
        if (stepData.standardInfo.length > 0 || getTCStandardGOTS) {
          setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
        } else {
          notify("Please Enter the Required Values", "error");
        }
      }
    }
  };

  const mapToPayload = (data: any, tcId: any, tcNetShippingWeight: any) => {
    return {
      tcId: tcId, // Main ID
      tcNetShippingWeight: tcNetShippingWeight, // Total shipping weight
      tcProductInformation: data.map((item: any, index: number) => ({
        tcProductOrder: (index + 1).toString(), // Populate if necessary
        tcProductNo: item.tcProductNo,
        tcProductOrderNo: item.tcProductOrderNo,
        tcProductArticleNo: item.tcProductArticleNo,
        tcProductNumberOfUnits: item.tcProductNumberOfUnits || 0,
        tcProductUnitsMetric: item.tcProductUnitsMetric,
        tcNetShippingWeight: item.tcNetShippingWeight,
        tcProductSupplementaryWeight:
          parseInt(item.tcProductSupplementaryWeight) || 0,
        tcProductProductionDate: item.tcProductProductionDate,
        tcProductCategoryCode: item.tcProductCategoryCode,
        tcProductCategoryCodeDescription:
          useTransactionCertificateStore
            .getState()
            .getProductCategoriesStore.find(
              (option: any) => option.value === item.tcProductCategoryCode
            )?.label || "",
        tcProductCategoryUserSpecificTerm:
          item.tcProductCategoryUserSpecificTerm,
        tcProductDetailCode: item.tcProductDetailCode,
        tcProductDetailUserSpecificTerm: item.tcProductDetailUserSpecificTerm,
        tcProductInfoTrimsExcluded: item.tcProductInfoTrimsExcluded,
        tcProductInfoAssociatedTc: item.tcProductInfoAssociatedTc,
        tcProductInfoFiberLength: item.tcProductInfoFiberLength,
        tcProductInfoYarnCount: item.tcProductInfoYarnCount,
        tcProductInfoFabricWeightAndConstruct:
          item.tcProductInfoFabricWeightAndConstruct,
        tcProductInfoFabricWeightOfFinishedProduct:
          item.tcProductInfoFabricWeightOfFinishedProduct,
        ocsProcessor: item.tcIsLastProcessorTECertitfied || "Y",
        tcProductLastProcessorName: item.tcProductLastProcessorName || "",
        tcProductLastProcessorTeId: item.tcProductLastProcessorTeId || "",
        tcProductLastProcessorLicenseNo:
          item.tcProductLastProcessorLicenseNo || "",
        tcProductLastProcessorCountry: item.tcProductLastProcessorCountry,
        tcProductLastProcessorCountryDescription:
          item.tcProductLastProcessorCountry
            ? useTransactionCertificateStore
                .getState()
                ?.getCountryCodes?.find(
                  (option: any) =>
                    option.value === item.tcProductLastProcessorCountry
                )?.label || ""
            : "",
        tcProductInfoAdditional: item.tcProductInfoAdditional,
        tcProductAdditives: item?.tcProductAdditives || [],
        tcProductAdditivesWeight: item?.tcProductAdditivesWeight,
        tcProductShipmentNo: item.tcProductShipmentNo,
        tcProductStandardInformation: (item["standardInfo"] || []).map(
          (rawMaterial: any, index: any) => ({
            tcProductStandardLabelOrder: (index + 1).toString(),
            tcProductStandardLabelGrade:
              rawMaterial.tcProductStandardLabelGrade,
            tcProductCertifiedWeight: rawMaterial.tcProductCertifiedWeight,
          })
        ),
        tcProductRawMaterialInformation: (item["raw-material-info"] || []).map(
          (rawMaterial: any) => ({
            tcProductRawMaterialOrder:
              rawMaterial.tcProductRawMaterialOrder.toString(),
            tcProductRawMaterialCode: rawMaterial.tcProductRawMaterialCode,
            tcProductRawMaterialPercentage:
              parseFloat(parseFloat(rawMaterial.tcProductRawMaterialPercentage).toFixed(2)),
            tcProductRawMaterialUserSpecificTerm: rawMaterial.tcProductRawMaterialUserSpecificTerm,
          })
        ),
      })),
    };
  };


  const onNext = () => {
    navigate(`/tc/${formtype}/component-details/${TE_ID}`);
  };
  const handleSave = async (payload: any) => {
    // const certifiedPrdtData: any = getCurrentTableData()
    // const totalNetShippingWeight = certifiedPrdtData.reduce((sum: any, item: any) => {
    //   return sum + parseFloat(item.tcNetShippingWeight || 0);
    // }, 0);
    // const payload = mapToPayload(certifiedPrdtData, TE_ID, totalNetShippingWeight);
    // TODO Commeneted for demo
    if (!TE_ID) {
      return;
    }
    const shipmentInfo = getShipmentIdsByNumbers(
      shipmentData,
      Array.isArray(stepData?.productInfo.tcProductShipmentNo)
        ? stepData?.productInfo.tcProductShipmentNo[0]
        : stepData?.productInfo.tcProductShipmentNo || ""
    );

    const oldShipmentIdArray = shipmentId ? [shipmentId] : [];
    const oldShipmentIdParam = JSON.stringify(oldShipmentIdArray);
    const oldShipmentNo = shipmentNo
      ? shipmentNo
      : payload?.tcProductInformation[0].tcAssociatedProductShipmentNo;
    const existingProductAndShipment: any = tableData.find(
      (item) => item.tcProductNo === payload.tcProductInformation[0].tcProductNo
    );
    const sameProdNewShipCreate = !isEdit ? existingProductAndShipment : null;
    const finalUrl = `${
      TCAppConfig.CERTIFIED_PRODUCT_DETAILS_ENDPOINT
    }?tcId=${TE_ID}&shipmentId=${shipmentInfo.shipmentId}&oldShipmentId=${
      shipmentId ? shipmentId : shipmentInfo?.shipmentId
    }&oldShipmentNo=${encodeURIComponent(
      encodeURIComponent(oldShipmentNo)
    )}&sameProdNewShipCreate=${
      sameProdNewShipCreate !== null && sameProdNewShipCreate !== undefined
        ? "Yes"
        : "No"
    }`;

    try {
      payload.tcProductInformation[0].tcProductRawMaterialInformation[0].tcProductRawMaterialUserSpecificTerm = stepData.rawMaterialInfo[0]['tcProductRawMaterialUserSpecificTerm'];

      const result: any = await executePost(finalUrl, {
        ...payload,
        tcProductInformation: [
          {
            ...payload?.tcProductInformation[0],
            tcAssociatedProductShipmentNo: Array.isArray(
              payload?.tcProductInformation[0]?.tcAssociatedProductShipmentNo
            )
              ? payload?.tcProductInformation[0]?.tcAssociatedProductShipmentNo
              : [
                  payload?.tcProductInformation[0]
                    ?.tcAssociatedProductShipmentNo,
                ],
          },
        ],
        ...(sameProdNewShipCreate !== null
          ? { productId: sameProdNewShipCreate?.productId }
          : isEdit && existingProductAndShipment?.productId === productId
          ? { productId: productId }
          : {}),
      });

      if (result.status == 200) {
        notify("Data Saved Successfully", "success");
        if (pendingSave) {
          setPendingSave(null);
        }
        fetchProductDetails();
        setStepData({
          productInfo: initTcProduct,
          standardInfo: initStandardInfo,
          lastProcessorInfo: initLastProcessorInfo,
          additionalInfo: initAdditonalInfo,
          rawMaterialInfo: initRawMaterialInfo,
        });

        toggleDrawer();
        await onNextTab();
      } else if (result.status === 409) {
        setLoadingState(false);
      } else {
        setLoadingState(false);
        notify("Unable to Save", "error");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
    setRestrictPopUpSave(false);
  };
  const handleFinish = async () => {
    if (isAdmin) {
      navigate(`/tc/${formtype}/component-details/${TE_ID}`);
      return;
    }
    
    if (activeStep === 1) {
      const totalPercentage = stepData.rawMaterialInfo.reduce((sum, item) => {
        const percent = parseFloat(item.tcProductRawMaterialPercentage || "0");
        return sum + (isNaN(percent) ? 0 : percent);
      }, 0);
      const roundedTotal = parseFloat(totalPercentage.toFixed(2));
      if (stepData.rawMaterialInfo && stepData.rawMaterialInfo.length <= 0) {
        notify("Raw Material Info is Required", "error");
        return;
      }
      if (roundedTotal !== 100) {
        notify("Total Product Raw Material Percentage should be 100", "error");
        return;
      }
    }
    if (activeStep === 4) {
      if (stepData.standardInfo.length <= 0) {
        notify("Standard Info is Required", "error");
        return;
      } else if (stepData.standardInfo.length > 0) {
        const totalStandardCertifiedWeight = stepData.standardInfo.reduce(
          (sum, item) => {
            const weight = parseFloat(item.tcProductCertifiedWeight || "0");
            return sum + (isNaN(weight) ? 0 : weight);
          },
          0
        );

        if (
          Math.abs(totalCertifiedWeight - Number(totalStandardCertifiedWeight.toFixed(2))) > 2
        ) {
          notify(
            "Total Certified Weight is not equal to the Standard Certified Raw Material Weight",
            "error"
          );
          return;
        }
      }
    }

    const shipmentInfo = getShipmentIdsByNumbers(
      shipmentData,
      Array.isArray(stepData?.productInfo.tcProductShipmentNo)
        ? stepData?.productInfo.tcProductShipmentNo[0]
        : stepData?.productInfo.tcProductShipmentNo || ""
    );

    if (TE_ID) {
      const payload = mapProductData(
        stepData,
        TE_ID,
        shipmentInfo?.tcShipmentDocNo,
        productId
      );

      if (productId && payload.tcProductInformation[0].tcProductNo) {
        //alert("test1")
        // Find the shipment in the table data that matches the provided productId
        const existingProduct: any = tableData.find(
          (item) => item.productId === productId
        );
        const isChanged =
          existingProduct &&
          existingProduct.tcProductNo !==
            payload.tcProductInformation[0].tcProductNo;
        // If the product exists and its number has changed, delete the old one first
        const isShipmentChanged = existingProduct != null; // && !_.isEqual(existingProduct.tcProductShipmentNo, payload.tcProductInformation[0].tcProductShipmentNo);
        console.log(
          isShipmentChanged,
          existingProduct?.tcProductShipmentNo,
          payload.tcProductInformation[0].tcProductShipmentNo,
          "32"
        );
        setIsValueChanged(isShipmentChanged || false);
        if (isChanged) {
          const row = {
            original: {
              tcProductNo: existingProduct?.tcProductNo,
              productId: productId,
            },
          };

          //alert("test2")
          // Delete the existing product first, then save the new one
          await onEditDelete(row);
          // The actual save will happen in the handleConfirmSave after deletion
          setPendingSave(payload);
          return;
        }

        // If it's a new product or no changes to product number, save directly
        handleSave(payload);
      } else if (!productId) {
        // This is a new product, not an edit
        // check whether product and shipment combination already exists
        handleSave(payload);
      }
    }

    // if (editingIndex === -1) {
    //   setDeleteSave(false)
    // const userFilledValues = getCurrentFormValues()

    // if (editingIndex >= 0) {
    //   updateTableRowbyIndex(editingIndex, userFilledValues)
    //   const certifiedProductsDatas = getCurrentTableData()
    //   setData(certifiedProductsDatas);
    //   if (getEditExistingShipment.index === editingIndex) {
    //     if (certifiedProductsDatas[editingIndex]?.tcProductNo != getEditExistingShipment.value) {
    //       setDeleteSave(true)
    //     }
    //     else {
    //       setEditExistingShipment({
    //         index: -1, value: ''
    //       })
    //       setDeleteSave(false)
    //     }
    //   }
    //   setNextEnabled(false)
    // } else {
    //   updateTableData([getCurrentFormValues()]);
    //   const certifiedProductsDatas = getCurrentTableData()
    //   setData(certifiedProductsDatas);
    //   setNextEnabled(false)
    // }
    // if (getDeleteSave()) {
    //   setPendingSave(userFilledValues)
    //   setDialogOpen(true)
    //   setPopUpBtnName("Save")
    //   setPopUpTitle("Confirm Edit ?")
    //   setPopUpMessage(`Editing Product No field will remove all the Associated Records, are you sure want to Save it`)
    //   // setDeleteSave(false)
    //   return null
    // }
    // // Reset editing index
    // setEditingIndex(-1);

    // Reset stepData to its initial state
    // Close the drawer
  };

  const actions: ActionButtonConfig[] = [
    ...activeStep!==0?[{
      label: "Back",
      onClick: handleBack,
      variant: "contained" as "contained",
      color: "default" as "default",
      disabled: activeStep === 0,
    }]:[],
    {
      label: isAdmin ? "Next" : (activeStep === steps.length - 1 ? "Save" : "Next"),
      onClick: activeStep === steps.length - 1 ? handleFinish : handleNext,
      variant: "contained" as "contained",
      color: "primary" as "primary",
      disabled:
        activeStep === 3 || activeStep === 1 || activeStep === 4
          ? isRestrictPopUpSave
          : activeStep === 4
          ? disableOnEdit
          : false,
      isLoading: nextLoader && activeStep === 0,
    },
  ];

  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "tcProductNo",
      header: "Product No.",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "tcProductOrderNo",
      header: "Order No.",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "tcProductArticleNo",
      header: "Article No.",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "tcProductNumberOfUnits",
      header: "Number of Units",
      minSize: 60,
      maxSize: 150,
      Cell: Utills.usNumberFormat,
    },
    {
      accessorKey: "tcProductUnitsMetric",
      header: "Units Metric",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "tcNetShippingWeight",
      header: "Net Shipping Weight (kg)",
      minSize: 60,
      maxSize: 150,
      Cell: Utills.usNumberFormat,
    },
    {
      accessorKey: "tcProductSupplementaryWeight",
      header: "Supplementary Weight (kg)",
      minSize: 60,
      maxSize: 150,
      Cell: Utills.usNumberFormat,
    },
    {
      accessorKey: "tcProductProductionDate",
      header: "Production Date",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "tcProductCategoryCodeDescription",
      header: "Product Category",
      minSize: 150,
      maxSize: 200,
    },

    {
      accessorKey: "tcProductShipmentNo",
      header: "TC Product Shipment No.",
      minSize: 60,
      Cell: ({ cell }) => {
        const selectedValues = cell.getValue() || []; // Get the array of selected values
        //(selectedValues, "43217809478213");

        return (
          <div>
            {Array.isArray(selectedValues) && selectedValues.length > 0
              ? selectedValues.join(", ") // Convert array to comma-separated string
              : ""}{" "}
            {/* Fallback if no value is selected */}
          </div>
        );
      },
      maxSize: 150,
    },

    {
      accessorKey: "tcProductInfoAssociatedTc",
      header: "Associated TC",
      minSize: 60,
      maxSize: 150,
    },
    // { accessorKey: 'tcProductCertifiedWeight', header: 'Certified Weight', minSize: 60, maxSize: 150, Cell: Utills.usNumberFormat },
    // { accessorKey: 'tcProductStandardLabelGrade', header: 'Standard Label Grade', minSize: 60, maxSize: 150 },
    // { accessorKey: 'tcProductStandardLabelOrder', header: 'Label Order', minSize: 60, maxSize: 150 },
  ];
  const renderDetailPanel = ({ row }: { row: any }) => {
    const lastProcessorInfo = {
      tcIsLastProcessorTECertitfied: row.original.tcIsLastProcessorTECertitfied,
      tcProductLastProcessorCountry: row.original.tcProductLastProcessorCountry,
      tcProductLastProcessorLicenseNo:
        row.original.tcProductLastProcessorLicenseNo,
      tcProductLastProcessorName: row.original.tcProductLastProcessorName,
      tcProductLastProcessorTeId: row.original.tcProductLastProcessorTeId,
    };
    const additionalInfo = {
      tcProductInfoFiberLength: row.original.tcProductInfoFiberLength,
      tcProductInfoYarnCount: row.original.tcProductInfoYarnCount,
      tcProductInfoFabricWeightAndConstruct:
        row.original.tcProductInfoFabricWeightAndConstruct,
      tcProductInfoFabricWeightOfFinishedProduct:
        row.original.tcProductInfoFabricWeightOfFinishedProduct,
      tcProductInfoTrimsExcluded: row.original.tcProductInfoTrimsExcluded,
      tcProductAdditives: row?.original?.tcProductAdditives,
      tcProductAdditivesWeight: row?.original?.tcProductAdditivesWeight,
    };
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: 5,
          gap: 4,
          width: "80%",
        }}
      >
        {/* First Table - Processor Information */}
        <Box sx={{ width: "100%", textAlign: "left", mb: 3 }} display="grid">
          <Typography variant="body2" fontWeight={"400"} sx={{ mb: 1 }}>
            Processor Information
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: "tcIsLastProcessorTECertitfied",
                header: "Last Processor TE-certified?",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductLastProcessorCountry",
                header: "Last Processor Country",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductLastProcessorTeId",
                header: "Last Processor TE-ID",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductLastProcessorName",
                header: "Last Processor Name",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductLastProcessorLicenseNo",
                header: "Last Processor License No.",
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={[lastProcessorInfo]}
            enableTopToolbar={false}
            enableRowActions={false}
            enableBottomToolbar={false}
          />
        </Box>
        <Divider />
        {/* Second Table - Fabric and Material Details */}
        <Box sx={{ width: "100%", textAlign: "left", mb: 3 }} display="grid">
          <Typography variant="body2" fontWeight={"400"} sx={{ mb: 1 }}>
            Fabric and Material Details
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: "tcProductInfoFiberLength",
                header: "Fiber Length (mm)",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductInfoYarnCount",
                header: "Yarn Count",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductInfoFabricWeightAndConstruct",
                header: "Fabric Weight and Construct (kg)",
                minSize: 60,
                maxSize: 150,
                Cell: Utills.usNumberFormat,
              },
              {
                accessorKey: "tcProductInfoFabricWeightOfFinishedProduct",
                header: "Fabric Weight of Finished Product (kg)",
                minSize: 60,
                maxSize: 150,
                Cell: Utills.usNumberFormat,
              },
              {
                accessorKey: "tcProductInfoTrimsExcluded",
                header: "Trim Excluded",
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={[additionalInfo]}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
        <Divider />
        {/* Third Table - Raw Material Composition */}
        <Box sx={{ width: "100%", textAlign: "left" }} display="grid">
          <Typography variant="body2" fontWeight={"400"} sx={{ mb: 1 }}>
            Standard Details
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: "tcProductCertifiedWeight",
                header: "Certified Weight (kg)",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductStandardLabelGrade",
                header: "Standard Label Grade",
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={row.original["standardInfo"]}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
        <Divider />
        {/* Third Table - Raw Material Composition */}
        <Box sx={{ width: "100%", textAlign: "left" }} display="grid">
          <Typography variant="body2" fontWeight={"400"} sx={{ mb: 1 }}>
            Raw Material Composition
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: "tcProductRawMaterialCode",
                header: "Raw Material Code",
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: "tcProductRawMaterialPercentage",
                header: "Raw Material Percentage",
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={row.original["raw-material-info"]}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
      </Box>
    );
  };

  const mapToCertifiedProductDetails = (data: any) => {
    Utills.cl("edit", data);
    return {
      tcId: data.associatedShipmentNo,
      tcNetShippingWeight: data.tcNetShippingWeight,
      tcProductInformation: {
        tcProductNo: data.tcProductNo,
        tcProductCategoryCode: data.tcProductCategoryCode,
        tcProductProductionDate: data.tcProductProductionDate,
        tcNetShippingWeight: data.tcNetShippingWeight,
        tcProductSupplementaryWeight: data.tcProductSupplementaryWeight,
        tcProductOrderNo: data.tcProductOrderNo,
        tcProductArticleNo: data.tcProductArticleNo,
        tcProductNumberOfUnits: data.tcProductNumberOfUnits,
        tcProductUnitsMetric: data.tcProductUnitsMetric,
        tcProductInfoAssociatedTc: data.tcProductInfoAssociatedTc,
        tcProductShipmentNo: data.tcProductShipmentNo || [],
        tcProductOrder: data.tcProductCategoryUserSpecificTerm, // Assuming this is what tcProductOrder maps to
        tcProductCategoryUserSpecificTerm:
          data.tcProductCategoryUserSpecificTerm,
        tcProductDetailCode: data.tcProductDetailCode,
        tcProductDetailUserSpecificTerm: data.tcProductDetailUserSpecificTerm,
      },
      tcProductStandardInformation: (data["standardInfo"] || []).map(
        (rawMaterial: any) => ({
          tcProductStandardLabelOrder:
            rawMaterial?.tcProductStandardLabelOrder.toString(),
          tcProductStandardLabelGrade:
            rawMaterial?.tcProductStandardLabelGrade || "",
          tcProductCertifiedWeight: rawMaterial?.tcProductCertifiedWeight || "",
        })
      ),
      tcProductLastProcessorInfo: {
        tcProductLastProcessorName: data.tcProductLastProcessorName || "",
        tcProductLastProcessorTeId: data.tcProductLastProcessorTeId || "",
        tcProductLastProcessorLicenseNo:
          data.tcProductLastProcessorLicenseNo || "",
        tcProductLastProcessorCountry: data.tcProductLastProcessorCountry || "",
        tcIsLastProcessorTECertitfied: data.tcIsLastProcessorTECertitfied || "",
      },
      tcProductAdditionalInfo: {
        tcProductInfoFiberLength: data.tcProductInfoFiberLength || "",
        tcProductInfoYarnCount: data.tcProductInfoYarnCount || "",
        tcProductInfoFabricWeightAndConstruct:
          data.tcProductInfoFabricWeightAndConstruct || "",
        tcProductInfoFabricWeightOfFinishedProduct:
          data.tcProductInfoFabricWeightOfFinishedProduct || "",
        tcProductInfoTrimsExcluded: data.tcProductInfoTrimsExcluded || "",
        tcProductInfoAdditional: data.tcProductInfoAdditional || "",
        tcProductAdditives: data?.tcProductAdditives || [],
        tcProductAdditivesWeight: data?.tcProductAdditivesWeight,
      },
      tcProductRawMaterialInformation: (data["raw-material-info"] || []).map(
        (rawMaterial: any) => ({
          tcProductRawMaterialOrder:
            rawMaterial.tcProductRawMaterialOrder.toString(),
          tcProductRawMaterialCode: rawMaterial.tcProductRawMaterialCode,
          tcProductRawMaterialPercentage:
            rawMaterial.tcProductRawMaterialPercentage.toString(),
        })
      ),
    };
  };
  const onEdit = (row: any) => {
    setIsEdit(true);
    const value = row?.original as ProductShipmentResponse;
    setProductId(value.productId);
    setShipmentId(value.shipmentId);
    setShipmentNo(
      value?.tcAssociatedProductShipmentNo &&
        value?.tcAssociatedProductShipmentNo?.length > 0
        ? value?.tcAssociatedProductShipmentNo[0]
        : null
    );
    if (TE_ID) {
      fetchProductaddDetails(
        executeGet,
        TE_ID,
        value.productId,
        value.shipmentId
      )
        .then((data) => {
          const productList = data?.data?.tcProductInformation;
          const netShippingWeight = data?.data?.tcNetShippingWeight;

          if (productList && productList.length > 0) {
            const product = productList[0];

            const mappedStepData = mapProductDataToStepData(
              product,
              netShippingWeight
            );
            console.log(mappedStepData);

            setStepData(mappedStepData);
          }
          toggleDrawer();
        })
        .catch((err) => notify(err.message, "error"));
    }
  };

  const onDelete = (row: any) => {
    const tcProductNo = row?.original?.tcProductNo;
    const productId = row?.original?.productId;
    setDeleteShpId(row?.original?.shipmentId);
    setDeleteShpNo(row?.original?.tcAssociatedProductShipmentNo[0]);
    setProductId(productId);
    setDialogOpen(true);
    setTcProductNo(tcProductNo);
    setPopUpBtnName("Delete");
    setPopUpTitle("Confirm Delete ?");
    setPopUpMessage(
      `Deleting Shipment ${tcProductNo} will remove all the Associated Records, are you sure want to delete it`
    );
  };
  const onEditDelete = (row: any) => {
    const tcProductNo = row?.original?.tcProductNo;
    const productId = row?.original?.productId;
    setTcProductNo(tcProductNo);
    setProductId(productId);
    setDialogOpen(true);
    setPopUpBtnName("Save");
    setPopUpTitle("Confirm Save ?");
    setPopUpMessage(
      `Editing Product No. ${tcProductNo} will remove all the Associated Records, are you sure want to edit it`
    );
  };
  const onAdd = () => {
    setIsEdit(false);
    toggleDrawer();
  };
  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
            {!hasSubmitTC && !isAdmin && (
              <StyledButton
                variant="contained"
                sx={{ boxShadow: "none" }}
                onClick={onAdd}
              >
                Add Product
              </StyledButton>
            )}
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={tableData}
              rowCount={rowCount}
              paginations={pagination}
              setPaginations={setPagination}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableRowActions={!hasSubmitTC}
              renderDetailPanel={({ row }) =>
                // Only mount the detail panel if the row is expanded
                row.getIsExpanded() ? (
                  <RenderDetailPanel row={row} />
                ) : (
                  <>NO data</>
                )
              }
              renderRowActions={({ row }) => (
                <ActionsMenu 
                  row={row} 
                  onEdit={onEdit} 
                  onDelete={!isAdmin ? onDelete : undefined} 
                />
              )}
            />
          </Box>
          <ActionsModalPopup
            open={drawerOpen}
            onClose={toggleDrawer}
            title="Add Product"
            actions={actions}
          >
            <CustomStepper
              steps={steps}
              activeStep={activeStep}
              onStepChange={(step) => setActiveStep(step)}
            />
          </ActionsModalPopup>

          {!drawerOpen ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                gap: "0.5rem",
              }}
            >
              {/* {!isNextEnabled && <InnerButton onClick={handleSave}>Save & Next</InnerButton>} */}
              <NavLink to="/tc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>
              {tableData?.length > 0 && (
                <InnerButton onClick={onNext}>Next</InnerButton>
              )}
            </Box>
          ) : (
            <>
              {hasSubmitTC && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 2,
                    gap: "0.5rem",
                  }}
                >
                  <NavLink to={`/tc/${formtype}/shipments/${TE_ID}`}>
                    <InnerButton sx={{ boxShadow: "none" }}>Back</InnerButton>
                  </NavLink>
                  <InnerButton onClick={onNext} sx={{ boxShadow: "none" }}>
                    Next
                  </InnerButton>
                </Box>
              )}
            </>
          )}

          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />
        </>
      )}
    </>
  );
};

export default CertifiedProductsComponents;
